export function uid(prefix = 'el_'): string {
  return `${prefix}${crypto.randomUUID().slice(0, 8)}`;
}
